import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { initGA } from './utils/analytics';
import { AuthProvider } from "./context/AuthContext";
import { CountryProvider } from "./context/CountryContext";
import { ThemeProvider } from "./context/ThemeContext";
initGA();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <CountryProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </CountryProvider>
    </AuthProvider>
  </BrowserRouter>
);

